<template>
  <div :class="iconClasses">
    <svg
      aria-hidden="true"
      focusable="false"
      role="img"
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 288 512"
    >
      <path
        fill="currentColor"
        d="M144 176c44.1 0 80 35.9 80 80s-35.9 80-80 80-80-35.9-80-80 35.9-80 80-80m0-64C64.5 112 0 176.5 0 256s64.5 144 144 144 144-64.5 144-144-64.5-144-144-144z"
      ></path>
    </svg>
  </div>
</template>

<script>
  export default {
    name: 'circle-empty',
    props: {
      extraClasses: {
        type: Array,
        default: function () {
          return []
        },
      },
    },
    computed: {
      iconClasses: function () {
        return ['icon', 'icon--circle-empty']
          .concat(this.extraClasses)
          .join(' ')
      },
    },
  }
</script>
